var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.24609 7.8399C2.24609 7.53071 2.391 7.23419 2.64893 7.01556C2.90686 6.79693 3.25669 6.6741 3.62146 6.6741H28.3781C28.7428 6.6741 29.0927 6.79693 29.3506 7.01556C29.6085 7.23419 29.7534 7.53071 29.7534 7.8399V24.1611C29.7534 24.4702 29.6085 24.7668 29.3506 24.9854C29.0927 25.204 28.7428 25.3268 28.3781 25.3268H3.62146C3.25669 25.3268 2.90686 25.204 2.64893 24.9854C2.391 24.7668 2.24609 24.4702 2.24609 24.1611V7.8399Z",
    stroke: "#3AB54A",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.24609 11.3378H29.7534",
    stroke: "#3AB54A",
    strokeWidth: 1.2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4325 21.7855H24.9318M29.7534 7.84052V17.1669M2.24609 7.84052V17.1669",
    stroke: "#3AB54A",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98145 18.8891V13.9871H6.90045C7.25305 13.9871 7.54715 14.0406 7.78273 14.1475C8.01832 14.2544 8.1954 14.4028 8.31397 14.5927C8.43254 14.781 8.49183 14.998 8.49183 15.2437C8.49183 15.4352 8.45439 15.6036 8.3795 15.7488C8.30461 15.8924 8.20164 16.0105 8.07058 16.103C7.94109 16.194 7.79287 16.2586 7.62593 16.2969V16.3448C7.80847 16.3527 7.97931 16.4054 8.13845 16.5027C8.29915 16.6001 8.42942 16.7365 8.52927 16.912C8.62912 17.086 8.67905 17.2934 8.67905 17.5344C8.67905 17.7945 8.61586 18.0266 8.48949 18.2309C8.36468 18.4335 8.17979 18.5939 7.93485 18.712C7.6899 18.8301 7.38801 18.8891 7.02917 18.8891H4.98145ZM5.99478 18.0418H6.82089C7.10328 18.0418 7.30922 17.9867 7.43871 17.8766C7.56821 17.7649 7.63296 17.6165 7.63296 17.4314C7.63296 17.2958 7.60097 17.1761 7.537 17.0724C7.47304 16.9687 7.38177 16.8873 7.26319 16.8283C7.14618 16.7692 7.00655 16.7397 6.84429 16.7397H5.99478V18.0418ZM5.99478 16.0384H6.746C6.88485 16.0384 7.00811 16.0137 7.11576 15.9642C7.22497 15.9131 7.31078 15.8413 7.37319 15.7488C7.43715 15.6562 7.46914 15.5453 7.46914 15.4161C7.46914 15.2389 7.40751 15.0961 7.28426 14.9876C7.16256 14.8791 6.98938 14.8249 6.76472 14.8249H5.99478V16.0384Z",
    fill: "#3AB54A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1645 18.8891H9.07865L10.7332 13.9871H12.0391L13.6913 18.8891H12.6054L11.4049 15.1073H11.3674L10.1645 18.8891ZM10.0967 16.9623H12.6616V17.7713H10.0967V16.9623Z",
    fill: "#3AB54A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.277 13.9871V18.8891H17.4018L15.3166 15.8038H15.2815V18.8891H14.2682V13.9871H15.1575L17.2262 17.07H17.2684V13.9871H18.277Z",
    fill: "#3AB54A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1142 18.8891V13.9871H20.1276V16.1485H20.1908L21.9155 13.9871H23.1301L21.3515 16.182L23.1512 18.8891H21.9389L20.6261 16.8737L20.1276 17.4961V18.8891H19.1142Z",
    fill: "#3AB54A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBank);
export default __webpack_public_path__ + "static/media/ic-bank.7c971334352bee6fd35e530bf9534c22.svg";
export { ForwardRef as ReactComponent };